export default "__VITE_ASSET__CpP0S5ro__"